<form (ngSubmit)="onSubmit.emit(this.bf.bigForm.value)" [formGroup]="bf.bigForm" class="form-horizontal">
	<div *ngFor="let field of fields">
		<field-generator *ngIf="field.level === 'field'" [field]="field" [form]="bf.bigForm"></field-generator>
		<!-- <field-group-generator *ngIf="field.level === 'group'" [group]="field" [form]="bf.bigForm"></field-group-generator> -->
	</div>
	<div class="form-row"></div>
	<div class="form-group row">
		<div class="col-md-3"></div>
		<!-- <div class="col-md-9"><button type="submit" class="btn btn-primary">Save</button> <strong>Saved all values</strong></div> -->
	</div>
</form>
